import React from 'react';
import './Loader.css'
import Lottie from "lottie-react";
import animationData from "./animation_lnpfl15n.json";

const Loader = () => {
  return (
    <div className="loader">
      <Lottie
                      animationData={animationData}
                      style={{
                       width:100
                      }}
                    />
    </div>
  );
};

export default Loader;
